"use client";

import React from "react";
import { useSelector } from "react-redux";

import ImageAtom, { MagnoliaImage } from "@/components/atoms/image/image";
import { RootState } from "@/store/root-reducer";
import { LoginButtonSectionProps } from "@/types/confirmation-types";

import Styles from "./confirmation-section.module.css";
import LoginButtonSection from "./login-button-section";
import Logo from "../logo-component/logo";

function LoginWithImageBannerAvanti({
  aboutCoverTitle,
  aboutCoverContent,
  aboutCoverBtnLabel,
  aboutCoverBtnLink,
  aboutCoverImage,
}: Readonly<LoginButtonSectionProps>) {
  const { attributes } = useSelector((state: RootState) => state.quote);

  const imageProps: MagnoliaImage | undefined | null =
    typeof aboutCoverImage === "string"
      ? {
          "@id": "",
          "@link": aboutCoverImage,
          "@name": "",
          "@path": "",
          "@type": "",
          "@uuid": "",
        }
      : aboutCoverImage;

  if (!attributes) return <div>Loading...</div>;

  return (
    <div
      className="flex flex-row justify-between"
      data-testid="loginWithImageAvantiSection-testid"
    >
      <div
        className=" lg:w-[620px] flex flex-col items-start gap-spacing-m md:gap-[21.15px]"
        data-testid="loginBtnSection-testid"
      >
        <div className="lg:gap-spacing-m">
          <Logo color="primary" size="xl" className="lg:!p-0 lg:m-0" />
        </div>
        <div className=" flex flex-col gap-spacing-l">
          <h1 className="font-header-font text-[26px] md:text-[39px] leading-[27.6px] md:leading-[45px] text-left px-[17px] md:px-[32.5px] md:pb-spacing-l text-text-title lg:py-0 lg:px-0">
            {attributes?.organiser?.firstName ? (
              <>
                {aboutCoverTitle}, <br className="lg:hidden block" />
                {attributes?.organiser?.firstName}
              </>
            ) : (
              <br />
            )}
          </h1>

          <div className="lg:block hidden">
            <LoginButtonSection
              aboutCoverContent={aboutCoverContent}
              aboutCoverBtnLabel={aboutCoverBtnLabel}
              aboutCoverBtnLink={aboutCoverBtnLink}
            />
          </div>
        </div>
      </div>

      <div className="w-[50%]">
        <div className="right-0 md:right-[33px] lg:right-[130px] mt-[24px] md:mt-[14px] lg:mt-0  absolute">
          {imageProps && (
            <div className="">
              <ImageAtom
                image={imageProps}
                styleClass={`${Styles.banner_image_block_avanti} h-fit`}
                data-testid="banner-image-testid"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LoginWithImageBannerAvanti;
